import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcDateTime',
  standalone: true,
})
export class UtcDateTimePipe implements PipeTransform {
  private datePipe = new DatePipe('en-US');

  private getTimeZoneAbbr(timeZone: string): string {
    // Map of IANA timezone names to their abbreviations
    const timeZoneMap: { [key: string]: string } = {
      'Asia/Kolkata': 'IST',
      'Asia/Calcutta': 'IST',
      'America/Los_Angeles': 'PST',
      'America/New_York': 'EST',
      'Europe/London': 'GMT',
      'Asia/Dubai': 'GST',
      'Asia/Singapore': 'SGT',
      'Australia/Sydney': 'AEST',
      'Pacific/Auckland': 'NZST',
      'Europe/Paris': 'CET',
      'Asia/Tokyo': 'JST'
    };

    // If we have a mapping, use it
    if (timeZoneMap[timeZone]) {
      return timeZoneMap[timeZone];
    }

    // If no mapping exists, try to get abbreviation from the date
    const date = new Date();
    const options = { timeZone, timeZoneName: 'short' as const };
    const timeZoneAbbr = new Intl.DateTimeFormat('en-US', options)
      .formatToParts(date)
      .find(part => part.type === 'timeZoneName')?.value;

    return timeZoneAbbr || timeZone;
  }

  transform(value: string | number | Date | undefined): string | undefined {
    if (!value) {
      return undefined;
    }

    try {
      const date = new Date(value);

      // Check if the date is valid
      if (isNaN(date.getTime())) {
        // console.warn('UtcDateTimePipe: Invalid date value:', value);
        return undefined;
      }

      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const timeZoneAbbr = this.getTimeZoneAbbr(timeZone);

      // Format the date using DatePipe
      const formatted = this.datePipe.transform(date, 'dd MMM yyyy, hh:mm:ss a');

      return formatted ? `${formatted} ${timeZoneAbbr}` : undefined;
    } catch (error) {
      console.error('Error in UtcDateTimePipe:', error);
      return undefined;
    }
  }
}
